import React, { Component } from 'react';
import { Col, Card, CardHeader, CardBody, Row } from 'reactstrap';
import update from '../../assets/fontawesome/update_big.png'
import Helmet from 'react-helmet'
import Mailchimp from '../../components/mailchimpForm';
import Revue from '../../components/revueForm';
import SignupForm from '../../components/signup';
import Cookies from 'js-cookie';

class ExportList extends Component {

  render() {
    return (
      <div className="animated fadeIn" style={{ height: '100%' }}>
        <Helmet>
          <title>Growjo - Export List</title>
          <meta name="description" content="Growjo: Update" />
          <meta name="author" content="Growjo"></meta>
        </Helmet>
        <Card style={{ height: '100%' }}>
          <CardHeader style={{ backgroundColor: 'white', color: '#1c1d38' }}>
            <img src={update} style={{ float: 'left', marginRight: 13, marginTop: 4 }} />
            <h1 style={{ color: '#474866', fontSize: 22, marginBottom: 0 }}>Export the Growjo 1,000 and more</h1>
          </CardHeader>
          <CardBody>
            <Row>
              <Col className='description' lg={6}>
                <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Join Growjo and get the 1,000 list for free
                </h4>
                </div>


                <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Get Company Competitor and Alternatives Data.
                </h4>
                </div>

                <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Get the ranking updates every other month
                </h4>
                </div>

                <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Export the fastest startups metro lists
                </h4>
                </div>
                <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Get access to new reports we are building
                </h4>
                </div>
                <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Annual Revenue & Sales Financials
                </h4>
                </div>
                <div style={{ lineHeight: '40px' }}>
                  <div style={{ height: 15, width: 15, backgroundColor: '#faa21b', borderRadius: '50%', float: 'left', marginTop: 14 }} />
                  <h4 style={{ color: '#29658a ', margin: 0, marginLeft: 30, lineHeight: '44px', fontSize: 16 }}>
                    Number of Employees Growth
                </h4>
                </div>
              </Col>
              <Col style={{ paddingTop: 20 }} lg={6}>
                <SignupForm />
              </Col>
            </Row>
            <div style={{ marginTop: 100, border: '1px solid grey', borderRadius: 16, padding: 5 }}>
              <img src='/static/exportlist/ExportList.png' alt='ExportList' width='100%' />
            </div>
            <h1 style={{ fontSize: 18, marginTop: 20, fontWeight: 'normal' }}>
              Fields include company name, url, city, state, country, employees, linkedin url, founded, Industry, Growjo Ranking, estimated_revenue, job openings, keywords, Lead Investors, Accelerator, business type, valuation, total funding, competitors, and growth percentage.
          </h1>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default ExportList;



// WEBPACK FOOTER //
// ./client/src/views/ExportList/index.js